window.onload = function() {
    var tabBlocks = document.querySelectorAll('.wp-block-synergies-blocks-tabs');

    tabBlocks.forEach(function(tabBlock, i) {

        var tabLabels = tabBlock.querySelectorAll('.tab-label');

        var tabPanels = tabBlock.querySelectorAll('.tab-panel');

        if (tabLabels.length > 5) {
            tabLabels.forEach(tabLabel => {
                tabLabel.style.minWidth = "auto";
            });
        }

        // Function to set active tab based on hash
        function setActiveTabFromHash() {
            const hash = window.location.hash;
            if (hash) {
                const tabId = hash.substring(1); // Remove the "#" character
                const tab = tabBlock.querySelector('.tab-label[id="' + tabId + '"]');
                console.log(tabId);
                if (tab) {
                    tabLabels.forEach(function(label) {
                        label.classList.remove('active');
                    });
                    tab.classList.add('active');
                }
            }
        }
        setTimeout(function() {
            setActiveTabFromHash();
        }, 200);
      
        // Function to set active tab class
        function setActiveTab(tabId) {
            tabLabels.forEach(function(label) {
                label.classList.remove('active');
                if (label.getAttribute('id') === tabId) {
                    label.classList.add('active');
                }
            });
        }

        tabLabels.forEach(function(tab) {
            tab.addEventListener("click", function(event) {
                event.preventDefault();
                const tabId = this.getAttribute("id");
        
                // Update URL with the new hash
                history.pushState(null, null, '#'+tabId);

                // Remove active class from all tab labels
                tabLabels.forEach(function(label) {
                    label.classList.remove('active');
                }); 

                // Add active class to the clicked tab label
                this.classList.add('active');
                return false;
            });
        });
        
        function removeTabParameter(url) {
            const urlObj = new URL(url);
            urlObj.searchParams.delete('tab');
            return urlObj.toString();
        }

        var setIDs = function(tabItems, i) {
            setTimeout(function() {
                //dyanamically adds ids to tab and tabpanel elements
                tabItems.forEach(function(element, index) {
                    const role = element.getAttribute('role');
                    const datatablabel = element.getAttribute('data-tablabel');
        
                    tabItems[index].id = `${datatablabel}-${i}-${index}`;
                });
            }, 100); // Adjust the delay as needed (100 milliseconds in this example)
        };

        setIDs(tabLabels, i);
        setIDs(tabPanels, i);

        var setAriaAttributes = function(tabItems, i) {
            //checks role and adds aria-controls and aria-labledby attributes if role is set to tab or tabpanel
            tabItems.forEach(function(element, index) {
                const role = element.getAttribute('role');
                if (role === 'tab') {
                    tabItems[index].setAttribute('aria-controls', `tabpanel-${i}-${index}`);
                } else if (role === 'tabpanel') {
                    tabItems[index].setAttribute('aria-labelledby', `tab-${i}-${index}`);
                }
                tabItems[index].id = `${role}-${i}-${index}`;
            });
        }
        setAriaAttributes(tabLabels, i);
        setAriaAttributes(tabPanels, i);

        //check for mouse click or enter keypress
        var toggleEvent = function(e) {
            if (e.type === 'click') {
                return true;
            } else if (e.type === 'keypress') {
                var code = e.charCode || e.keyCode;
                if ((code === 32) || (code === 13)) {
                    return true;
                }
            } else {
                return false;
            }
        } //a11yEvent

        var toggleAttributes = function(label, i) {
            var activeTab = tabBlock.querySelector('.tab-label.active');
            var activePanel = tabBlock.querySelector('.tab-panel.active');

            activeTab.classList.remove('active');
            activeTab.setAttribute('tabindex', 0);
            activeTab.setAttribute('aria-selected', false);

            label.classList.add('active');
            label.setAttribute('tabindex', -1);
            label.setAttribute('aria-selected', true);

            activePanel.classList.remove('active');
            activePanel.setAttribute('tabindex', 0);
            activePanel.setAttribute('aria-selected', false);
            activePanel.setAttribute('hidden', true);

            tabPanels[i].classList.add('active');
            tabPanels[i].removeAttribute('hidden');
        }

        tabLabels.forEach(function(label, i) {
            if (label.classList.contains('active')) {
                tabPanels[i].classList.toggle('active');
            }

            label.addEventListener('click', function(e) {
                if (toggleEvent(e) === true) {
                    toggleAttributes(label, i);
                }
            });
            label.addEventListener('keypress', function(e) {
                if (toggleEvent(e) === true) {
                    toggleAttributes(label, i);
                }
            });
        });
        
    }); //tabBlocks forEach



    if (window.location.hash) {
        // Get the element with the corresponding id
        setTimeout(function() {
        const targetElement = document.querySelector(window.location.hash);
    
        // Scroll to the element if found with an offset of 100 pixels from the top
        if (targetElement) {
            // Smooth scrolling to the element with an offset
            window.scrollTo({
                top: targetElement.offsetTop - 100, // Adjust the offset here
                behavior: 'smooth'
            });
        }
    }, 100);
    }
};
